import {StoreType} from '..';
//types
import {
	IOrganizationTableTicketsResponse,
	IOrganizationTablesAndTicketsAvailableResponse,
	IOrganizationTicketsListResponse,
	IOrganizationTicketsStatistics,
	IOrganizationTicketsTiers,
} from '../../utils/types';

export const getTablesAndTicketsLoaderSelector = (state: StoreType): boolean =>
	state.organizationTablesAndTicketsStore.isLoading;

export const getTablesAndTicketsListSelector = (state: StoreType): IOrganizationTicketsListResponse =>
	state.organizationTablesAndTicketsStore.ticketsList;

export const getTablesAndTicketsTiersSelector = (state: StoreType): IOrganizationTicketsTiers[] | null =>
	state.organizationTablesAndTicketsStore.ticketsTiers;

export const getTablesAndTicketsStatisticsSelector = (state: StoreType): IOrganizationTicketsStatistics | null =>
	state.organizationTablesAndTicketsStore.ticketsStatistics;

export const getTablesAndTicketsAvailableSelector = (
	state: StoreType
): IOrganizationTablesAndTicketsAvailableResponse => state.organizationTablesAndTicketsStore.ticketsAvailable;

export const getTicketsTableSelector = (state: StoreType): IOrganizationTableTicketsResponse | null =>
	state.organizationTablesAndTicketsStore.ticketsTable;

export const getPrivateTablesAndTicketsTiersSelector = (state: StoreType): IOrganizationTicketsTiers[] | null =>
	state.organizationTablesAndTicketsStore.privateTicketsTiers;
